package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.profile.ui.OwnerItem
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.alltasks.AllTasksEvent
import com.essntl.features.task.ui.alltasks.AllTasksNavigation
import com.essntl.features.task.ui.alltasks.AllTasksState
import com.essntl.features.task.ui.alltasks.rememberCategory
import com.essntl.features.task.ui.sharedtask.rememberItinerary
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonColors
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate

@Composable
fun TaskItem(
    state: AllTasksState,
    onEvent: (AllTasksEvent) -> Unit,
    onNavigation: (AllTasksNavigation) -> Unit,
    index: Int,
    task: TaskModel,
    isSelected: Boolean,
    modifier: Modifier = Modifier,
    overdue: Boolean = false,
) {
    val itinerary = state.sharedTaskState.rememberItinerary(
        itineraryId = task.itineraryService?.itineraryId,
        serviceItineraryId = task.itinerary?.id,
    )
    val category = state.rememberCategory(id = task.itineraryService?.service?.category)

    val interactionSource = remember { MutableInteractionSource() }

    val isHovered by interactionSource.collectIsHoveredAsState()

    val isPressed by interactionSource.collectIsPressedAsState()

    Column(
        modifier = modifier
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .background(
                    when {
                        isSelected ->
                            MaterialTheme.esColorScheme.tintedPressed

                        isPressed ->
                            MaterialTheme.esColorScheme.tintedPressed

                        isHovered ->
                            MaterialTheme.esColorScheme.tintedHover

                        index % 2 == 0 ->
                            MaterialTheme.esColorScheme.bgSecondaryHover.copy(alpha = 0.7f)

                        else ->
                            Color.Transparent
                    },
                )
                .padding(
                    vertical = EsConstants.ListRowVerticalPadding,
                    horizontal = EsConstants.ListRowHorizontalPadding,
                )
                .height(EsConstants.ListRowItemHeight)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable(
                    interactionSource = interactionSource,
                    indication = null,
                    enabled = !overdue,
                    onClick = {
                        onNavigation(AllTasksNavigation.EditTask(task.id))
                    },
                ),
        ) {
            // Task notes
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .weight(2f)
                    .fillMaxHeight(),
            ) {
                if (task.isOwnerTask) {
                    Icon(
                        imageVector = Icons.Default.Person,
                        contentDescription = "owner",
                        tint = MaterialTheme.esColorScheme.iconPrimary,
                        modifier = Modifier
                            .size(20.dp),
                    )
                    Spacer(modifier = Modifier.width(1f.spacing))
                } else if (!category?.iconUrl.isNullOrBlank() && task.itineraryService?.service != null) {
                    AsyncUrlIcon(
                        url = category?.iconUrl ?: "",
                        contentDescription = category?.name,
                        tint = Color(0xFF8985A2),
                        modifier = Modifier
                            .size(24.dp),
                    )

                    Spacer(modifier = Modifier.width(1f.spacing))
                } else {
                    EsMediumIcon(
                        res = EsIcons.Itinerary,
                    )
                    Spacer(modifier = Modifier.width(1f.spacing))
                }

                Box(
                    contentAlignment = Alignment.Center,
                    modifier = Modifier
                        .weight(2f)
                        .fillMaxSize(),
                ) {
                    Text(
                        text = task.title ?: "No title!",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.s2SemiBold16,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier
                            .align(Alignment.CenterStart),
                    )
                }
            }

            // Owner
            val isUpdateTaskOwnerLoading =
                rememberEquals(task.id, state.updateTaskOwnerLoading.toSet()) { it }

            EsRowDefaultItem(
                text = "",
                extraContent = {
                    OwnerItem(
                        ownerId = task.owner?.id,
                        getAllProfile = state.getAllProfile,
                        isUpdateOwnerLoading = isUpdateTaskOwnerLoading,
                        enabled = !overdue,
                        onOwnerChange = { profile ->
                            onEvent(AllTasksEvent.UpdateTaskOwner(task.id, profile))
                        },
                    )
                },
            )

            // Status
            EsRowDefaultItem(
                text = "",
                extraContent = {
                    task.status?.let {
                        TaskStatusDropDown(
                            status = it,
                            enabled = true,
                            onStatusSelected = { newStatus ->
                                if (newStatus != task.status)
                                    onEvent(AllTasksEvent.UpdateTaskStatus(task.id, newStatus))
                            },
                        )
                    }
                },
            )

            // Due Date
            EsRowDefaultItem(
                text = task.dueDate?.formatDate(
                    separator = ".",
                    excludeYear = true,
                ) ?: "_",
            )

            // Client
            val esColorScheme = MaterialTheme.esColorScheme
            EsRowDefaultItem(
                text = "",
                extraContent = {
                    EsButton(
                        onClick = {
                            val client = itinerary?.proposal?.primaryClient
                            if (itinerary != null &&
                                client != null
                            ) onNavigation(AllTasksNavigation.EditClient(client, itinerary))
                        },
                        size = EsButtonSize.Small,
                        colors = EsButtonColors(
                            containerColor = esColorScheme.bgPrimary,
                            disabledContainerColor = esColorScheme.bgPrimary,
                            pressedContainerColor = esColorScheme.ghostPressed.copy(alpha = .8f),
                            hoveredContainerColor = esColorScheme.ghostPressed,
                            focusedContainerColor = esColorScheme.bgPrimary,
                            textColor = esColorScheme.textPrimary,
                            disabledTextColor = esColorScheme.textDisabled,
                            iconColor = esColorScheme.iconPrimary,
                            disabledIconColor = esColorScheme.iconDisabled,
                            borderFocusColor = esColorScheme.bgPrimary,
                        ),
                        text = (itinerary?.proposal?.primaryClient?.firstName
                            ?: "-") + " " + (itinerary?.proposal?.primaryClient?.lastName ?: ""),
                        modifier = Modifier
                            .focusProperties { canFocus = false },
                    )
                },
            )

            // Service
            EsRowDefaultItem(
                text = task.itineraryService?.service?.title ?: "-",
            )
        }
    }
}